import { Check } from 'lucide-react';

import { MonoChip } from './MonoChip';

/** Verbatim isolation note (design §12.2/§28) — shared by wizard + detail page. */
export const MEMORY_ISOLATION_NOTE =
  "It can't see your other files — memory is isolated to a dedicated service principal that owns exactly one collection.";

/**
 * The memory grant display (design §12) — STATIC rows: read/write are granted
 * as a unit by the P2-T4 endpoint; the display must not imply per-permission
 * toggles (audit #4, D5). Copy states exactly what the backend mints.
 */
export function GrantPanel({ className }: { className?: string }) {
  return (
    <div className={className}>
      <div className="space-y-2 rounded-lg border bg-card p-4">
        <p className="text-sm font-medium">What the agent can do</p>
        <div className="flex items-start gap-2">
          <Check className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
          <div className="space-y-1">
            <p className="text-sm">Read and write files in its memory collection</p>
            <p className="flex flex-wrap items-center gap-1.5">
              <MonoChip>storage:read</MonoChip>
              <MonoChip>storage:write</MonoChip>
              <span className="text-sm text-muted-foreground" aria-hidden="true">
                →
              </span>
              <MonoChip>storage:files</MonoChip>
            </p>
          </div>
        </div>
        <div className="flex items-start gap-2">
          <Check className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
          <div className="space-y-1">
            <p className="text-sm">Create its memory collection</p>
            <p className="flex flex-wrap items-center gap-1.5">
              <MonoChip>storage:write</MonoChip>
              <span className="text-sm text-muted-foreground" aria-hidden="true">
                →
              </span>
              <MonoChip>storage:collections</MonoChip>
            </p>
          </div>
        </div>
      </div>
      <p className="mt-2 text-sm text-muted-foreground">{MEMORY_ISOLATION_NOTE}</p>
    </div>
  );
}
